import { Box, TextField, Typography } from '@mui/material';
import AITextSuggestLogo from '@assets/aiTextSuggestLogo.svg';
import { FC } from 'react';

interface AISuggestedTextProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  charLimit?: number;
}

export const AISuggestedText: FC<AISuggestedTextProps> = ({
  title,
  value,
  onChange,
  disabled,
  charLimit,
}) => {
  const isError = charLimit ? value.length > charLimit : false;
  return (
    <Box
      sx={{
        background:
          'linear-gradient(225deg, #008B5B, #ABE1CE, #133F6E, #008B5B)',
        backgroundSize: '300%',
        p: '2px',
        animation: 'linear-bg 3s infinite alternate',
        borderRadius: '4px',
      }}
    >
      <Box
        sx={{
          background: '#fff',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          borderRadius: '4px',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box component='img' src={AITextSuggestLogo} />
          <Typography variant='subtitle2'>{title}</Typography>
        </Box>
        <TextField
          disabled={disabled}
          value={value}
          onChange={event => onChange(event.target.value)}
          multiline
          minRows={3}
          fullWidth
          autoFocus
          error={isError}
          helperText={
            isError
              ? `This input must be ${charLimit} characters or less. Please reduce the length to proceed.`
              : charLimit && `${value ? value.length + `/${charLimit}` : ''}`
          }
          slotProps={{
            formHelperText: {
              style: {
                textAlign: isError ? 'left' : 'right',
              },
            },
          }}
          onFocus={e => {
            const tempValue = e.target.value;
            e.target.value = '';
            e.target.value = tempValue;
          }}
        />
      </Box>
    </Box>
  );
};
